<div *ngIf="!isLoading else loadingView">
    <p>Do you really want to delete those properties</p>
    <div class="cas-flex-row mb-2">
        <div class="p-col-3"><b>Type</b></div>
        <div class="p-col-3"><b>Name</b></div>
        <div class="p-col-3"><b>Value</b></div>
        <div class="p-col-3"><b>Remarks</b></div>
    </div>
    <hr/>
    <div class="cas-flex-row" *ngFor="let property of functions">
        <div class="p-col-3">{{property.predefinedType}}</div>
        <div class="p-col-3">{{property.predefinedName}}</div>
        <div class="p-col-3">{{property.value}}</div>
        <div class="p-col-3">{{property.remarks}}</div>
    </div>
    <div class="cas-action-buttons">
        <button class="cas-button-action" (click)="deleteRecords()">OK</button>
    </div>
</div>
<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
